// extracted by mini-css-extract-plugin
export default {"loader":"loading_loader__TREde","spin":"loading_spin__w0LOX"};